
import DivSpan from '@/components/DivSpan';
import fileUpload from '@/components/file-upload';
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'

import BizBrowse from '@/components/biz-browse';

export default {
name: "supplier-dynamic-form-value",
components: {
DivSpan,
fileUpload,
InlineXSwitch,
BizBrowse
},
data() {
return {
configData: {},
singleLineTables: [],
multipleLineTables: [],
tableObj: {},
newValueData: {},
currentPerson: {}
}
},
props: ['dynamicFormCode', 'valueData'],
methods: {

compare(property) {
return function (a, b) {
let value1 = a[property];
let value2 = b[property];
return value1 - value2;
}
},
getConfigData() {
this.$get('/api/dynamic-form/code/' + this.dynamicFormCode).then((data) => {
this.configData = data;
this.singleLineTables = this.configData.dynamicTables.filter(item => item.dataType === 'Single');
this.multipleLineTables = this.configData.dynamicTables.filter(item => item.dataType === 'Multiple');
if (this.multipleLineTables.length) {
this.multipleLineTables.sort(this.compare('orderNumber'));
this.tableObj = this.multipleLineTables[0];
}
this.initData();
}).catch((err) => {
console.log(err)
});
},
initData() {
if (!this.configData.dynamicTables) {
return;
}
this.configData.dynamicTables.forEach(table => {
if (!this.newValueData) {
this.newValueData = {
data: {}
};
}
if (!this.newValueData.data) {
this.newValueData.data = {};
}
if (!this.newValueData.data[table.tableName]) {
if (table.dataType === 'Single') {
this.newValueData.data[table.tableName] = {};
table.dynamicFields.forEach(field => {
if (field.inputType === 'LONG_TEXT' || field.inputType === 'ATTACHMENT') {
if (!this.newValueData.data[table.tableName][field.fieldName]) {
this.newValueData.data[table.tableName][field.fieldName] = {};
}
} else {
if (!this.newValueData.data[table.tableName][field.fieldName] && field.defaultValue) {
this.newValueData.data[table.tableName][field.fieldName] = this.getDefaultValue(field.defaultValue);
}
}
});
} else if (table.dataType == 'Multiple') {
this.newValueData.data[table.tableName] = [];
}
} else {
if (table.dataType == 'Single') {
table.dynamicFields.forEach(field => {
if (field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT') {
if (!this.newValueData.data[table.tableName][field.fieldName]) {
this.newValueData.data[table.tableName][field.fieldName] = {};
}
}
});
} else if (table.dataType == 'Multiple') {
table.dynamicFields.forEach(field => {
if (field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT') {
for (let i = 0; i < this.newValueData.data[table.tableName].length; i++) {
if (!this.newValueData.data[table.tableName][i][field.fieldName]) {
this.newValueData.data[table.tableName][i][field.fieldName] = {};
}
}
}
});
}
}
});
},
person() {
this.$get('api/person/current').then((data) => {
this.currentPerson = data;
})
},
getDefaultValue(key) {
switch (key) {
case '${currentDate}':
return new Date();
case '${currentPersonId}':
return this.currentPerson.id;
case '${currentPersonORGID}':
return this.currentPerson.orgId;
case '${currentPersonDEPTID}':
return this.currentPerson.depId;
case '${currentPersonName}':
return this.currentPerson.name;
case '${currentPersonPhone}':
return this.currentPerson.phone;
case '${currentSupplier}':
return this.currentPerson;
case '${currentSupplierId}':
return this.currentPerson.id;
case '${currentSupplierName}':
return this.currentPerson.supplierName;
default:
return key;
}
},
onItemClick(tableItem) {
this.tableObj = tableItem;
},
changeShow(item) {
if (item.cellShow) {
this.$set(item, 'cellShow', false);
return;
}
this.$set(item, 'cellShow', true);
}
},
mounted() {
this.person();
this.newValueData = this.valueData;
this.getConfigData();
},
watch: {
valueData() {
this.person();
this.newValueData = this.valueData;
this.initData();
}
}
}



// WEBPACK FOOTER //
// ./src/components/supplier-dynamic-form-value.vue